export const library = [
  {
    title: "My Favorites",
    image:
      "https://gateway.moralisipfs.com/ipfs/QmUG5tHQS8aw3v8KwZ4TuaF7AQC8SqEPatEwcanbTT9HvH/media/coverImage.jpeg",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Hyperspace",
    image:
      "https://www.digitalartsonline.co.uk/cmsdata/slideshow/3776245/beck_-_hyperspace.jpg",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Get Rich Or Die Tryin'",
    image: "https://m.media-amazon.com/images/I/61AYpcmBtpL._SY450_.jpg",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Starboy",
    image:
      "https://i.pinimg.com/originals/49/a0/7a/49a07a20041787942f62dbe900573ecb.jpg",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Evolve",
    image:
      "https://external-preview.redd.it/v_5XzwOWnjqrz5gBDfENNoMV9Kl8OAAy3015hcTsVYs.jpg?auto=webp&s=5485881fc8e107c14bca6d16c61fa085a78b70b6",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Ball Breaker",
    image:
      "https://scale.coolshop-cdn.com/product-media.coolshop-cdn.com/AN5W2E/b0cb0df8c30d479da36443c10bc85b96.jpg/f/ac-dc-ballbreaker-framed-album-cover-30x30cm.jpg",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Flavors",
    image:
      "https://fiverr-res.cloudinary.com/images/q_auto,f_auto/gigs/125831034/original/c2e1426823f87d01f7b43085c6b20e61b0736794/create-you-a-special-artistic-album-cover.png",

    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Shakira",
    image:
      "https://upload.wikimedia.org/wikipedia/en/3/35/Shakira_-_Shakira_%282014%29.png",

    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Adele 21",
    image:
      "https://upload.wikimedia.org/wikipedia/fi/5/51/Adele21albumikansi.jpg",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Strange Clouds",
    image:
      "https://upload.wikimedia.org/wikipedia/en/6/69/B.o.B_-_Strange_Clouds_-_LP_Cover.jpg",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Shadow",
    image:
      "https://ipfs.moralis.io:2053/ipfs/QmX5NMV8hh1g5EcebX1e2Y55uQnVnKPk8YzW37wpnRWfXp/media/6",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Arctic Monkeys",
    image:
      "https://i.pinimg.com/originals/c1/83/44/c1834474ec73e7faa475d68fdd791a48.jpg",
  },
  {
    title: "My Everything",
    image:
      "https://upload.wikimedia.org/wikipedia/en/d/d5/Ariana_Grande_My_Everything_2014_album_artwork.png",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Have A Nice Day",
    image:
      "https://upload.wikimedia.org/wikipedia/de/thumb/e/e5/Bon_Jovi_Have_a_Nice_Day.svg/1200px-Bon_Jovi_Have_a_Nice_Day.svg.png",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Happier",
    image:
      "https://upload.wikimedia.org/wikipedia/en/e/e5/Marshmello_and_Bastille_Happier.png",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "Stoney",
    image:
      "https://upload.wikimedia.org/wikipedia/fi/d/d9/Post_Malone_Stoney.jpg",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
  {
    title: "The Eminem Show",
    image: "https://upload.wikimedia.org/wikipedia/en/3/35/The_Eminem_Show.jpg",
    contract: "0xe38E3A8c40c0A4d51F0F5dd6756227db328aCf46",
  },
];
